import $ from "jquery";

$(() => {
  if (document.querySelector(".our-listings")) {
    const listings = $(".our-listings");
    const tabs = listings.children(".tab-wrapper").children(".tabs");
    const buttons = tabs.children("button");
    const search = listings.children(".search-area");
    const views = search.children("div");

    const clearActive = () => {
      buttons.removeClass("active");
      views.removeClass("active");
    };
    const hello = (button) => {
      clearActive();
      let buttonClicked = "." + button.classList[0];
      tabs.children(buttonClicked).addClass("active");
      search.children(buttonClicked).addClass("active");
      // window.location.replace(url)
    };
    buttons.on("click", function () {
      hello(this);
    });

    if (window.location.hash.substring(1) === "brokers") {
      clearActive();
      $(buttons[1]).addClass("active");
      $(views[1]).addClass("active");
    }

    const nextButton = $(".next");
    nextButton.map(function () {
      this.text = "";
      this.innerHTML = `<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16.6562" r="15.5"></circle>
      <path d="M18.1334 20.923L22.4001 16.6563L18.1334 12.3896" stroke-linecap="round"></path>
      <path d="M9.6001 16.6562H21.689" stroke-linecap="round"></path>
      <path d="M22.4002 16.6562H21.6891" stroke-linecap="round"></path>
      <rect x="0.5" y="1.15625" width="31" height="31" rx="15.5"></rect>
      </svg>`;
    });

    const prevButton = $(".prev");
    prevButton.map(function () {
      this.text = "";
      this.innerHTML = `<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16.5" cy="16.6562" r="15.5" transform="rotate(-180 16.5 16.6562)"></circle>
      <path d="M14.3665 12.3894L10.0998 16.6561L14.3665 20.9227" stroke-linecap="round"></path>
      <path d="M22.8999 16.6562L10.811 16.6562" stroke-linecap="round"></path>
      <path d="M10.0998 16.6562L10.8109 16.6562" stroke-linecap="round"></path>
      <rect x="32" y="32.1562" width="31" height="31" rx="15.5" transform="rotate(-180 32 32.1562)"></rect>
      </svg>`;
    });

    var sortBy = "";
    const searchResults = $(".search-results");
    const newSort = () => {
      if (sortBy != $("#search-sort :selected").val()) {
        sortBy = $("#search-sort :selected").val();
        searchResults.children().addClass("hidden");
        searchResults.children("." + sortBy).removeClass("hidden");
      }
    };
    $(".search-sort").on("click", function () {
      newSort();
    });

    const resetButton = $(".es-button-gray");
    resetButton.addClass("button-reset");
    resetButton.removeClass("es-button-gray");

    const searchButton = $(".es-button-orange-corner");
    searchButton.addClass("button-search");
    searchButton.removeClass("es-button-orange-corner");

    const propertyMap = $(".es-widget-map-wrap");
    propertyMap.css({ height: "" });
    propertyMap.addClass("closed");

    const mapToggle = () => {
      propertyMap.toggleClass("closed");
      $("#map-toggle").toggleClass("closed");
    };

    $("#map-toggle").on("click", function () {
      mapToggle();
    });

    $(".featured:contains('Nothing to display')").text(
      "Your search returned no results, please try again"
    );

    const linkScuttle = () => {
      $(".es-overlay__content").children("a").removeAttr("target");
      $(".es-overlay__image").children("a").removeAttr("target");
      $(".es-overlay__title").children("a").removeAttr("target");
    };

    setTimeout(function () {
      const overlayWrap = $(propertyMap)
        .children(".es-properties-map")
        .children("div:nth-child(1)")
        .children(".gm-style")
        .children("div:nth-child(2)")
        .children("div:nth-child(2)")
        .children("div:nth-child(1)")
        .children("div:nth-child(4)")[0];
      let observer = new MutationObserver(linkScuttle);
      observer.observe(overlayWrap, { childList: true, subtree: true });
    }, 1000);
    // $(propertyMap).on("click", function(){ linkScuttle(); });

    // $(".es-search__field--es_type").find(".select2-search__field").val("Development Land");

    // const overlayConfig = () => {
    //   const overlaySwap = () => {
    //     console.log("overlaying");
    //     const overlays = $(".es-overlay__inner");
    //     console.log(overlays);
    //     if (overlays.length) {
    //       overlays.each((i, overlay) => {
    //         const title = $(overlay).children(".es-overlay__head").children(".es-overlay__title")
    //         const content = $(overlay).children(".es-overlay__info").children(".es-overlay__content")
    //         title.detach().appendTo(content);
    //       });
    //     };
    //   };

    //   const roleButton = $(".gm-style").children("div:nth-child(2)").children("div:nth-child(2)").children("div:nth-child(1)").children("div:nth-child(3)").children("div");

    //   const overlayDelay = () => {
    //     setTimeout(() => {overlaySwap();}, 500)
    //   }

    //   roleButton.on("click", function(){ overlayDelay(); });
    // };

    // $("#map-toggle").on("click", function(){overlayConfig(); });
  }
});
